export const defaultGraphData = {
  nodes: [
    {
      id: 'node_id_1',
      type: 'custom-rect',
      x: 500,
      y: 100,
      text: {x: 500, y: 100, value: '流程开始节点'},
      properties: {type: 'start', name: '流程开始节点', widgets: []},
    },
    // {
    //   id: "node_id_3",
    //   type: "custom-rect",
    //   x: 500,
    //   y: 200,
    //   text: {x: 500, y: 200, value: '流程节点'},
    //   properties: {type: 'node', name: '流程节点', chargers: ['user1', 'user3'], widgets: [{key: "1649843962000_52482", view: false, edit: true}], approval: 1}
    // },
    {
      id: 'node_id_2',
      type: 'custom-rect',
      x: 500,
      y: 300,
      text: {x: 500, y: 300, value: '流程结束节点'},
      properties: {type: 'end'},
    },
  ],
  edges: [
    // {
    //   id: "edge_id1",
    //   type: "polyline",
    //   sourceNodeId: "node_id_1",
    //   targetNodeId: "node_id_3",
    //   properties: {type: 'line'}
    // },
    // {
    //   id: "edge_id2",
    //   type: "polyline",
    //   sourceNodeId: "node_id_3",
    //   targetNodeId: "node_id_2",
    //   properties: {type: 'line'}
    // }
  ],
}

export function lf2Data(data) {
  const dataNew = {}
  //get all paths from edges
  if (data === []) {
    return dataNew
  }
  var node_index = 1
  for (let i = 0; i < data.nodes.length; i++) {
    let node = data.nodes[i]
    let properties = node.properties
    var parents = []
    var children = []
    var path = []
    var flow_id = 0
    if (properties.type === 'start') {
      flow_id = 0
    } else if (properties.type === 'end') {
      flow_id = -1
    } else {
      flow_id = node_index
      node_index++
    }
    var condition = {}
    for (let j = 0; j < data.edges.length; j++) {
      let edge = data.edges[j]
      if (edge.targetNodeId === node.id) {
        parents.push(edge.sourceNodeId)
        if (typeof edge.properties.condition !== 'undefined') {
          condition[edge.sourceNodeId] = edge.properties.condition
        }
      }
      if (edge.sourceNodeId === node.id) {
        children.push(edge.targetNodeId)
      }
    }
    dataNew[node.id] = {
      id: node.id,
      flow_id: flow_id,
      name: node.text.value,
      x: node.x,
      y: node.y,
      approval: properties.approval,
      condition: condition,
      parents: parents,
      children: children,
      path: path,
      widgets: properties.widgets,
      members: properties.members,
      comment: properties.comment,
    }
  }
  let getNodePaths = function (node_id) {
    if (typeof dataNew[node_id] === 'undefined') {
      return []
    }
    let node = dataNew[node_id]
    if (node.flow_id === 0) {
      return []
    }
    var path = []
    for (let i = 0; i < node.parents.length; i++) {
      let parent = dataNew[node.parents[i]]
      let parent_path = getNodePaths(parent.id)
      // console.log("parent", parent);
      // console.log("parent_path", parent_path);
      if (parent_path.length > 0) {
        for (let j = 0; j < parent_path.length; j++) {
          var _path = parent_path[j]
          _path.push(parent.flow_id)
          path.push(_path)
        }
      } else {
        path.push([parent.flow_id])
      }

    }
    return path
  }
  //for dataNew
  // getNodePaths('node_id_1');
  // getNodePaths('node_id_2');
  for (let node_id in dataNew) {
    let node = dataNew[node_id]
    node.path = getNodePaths(node_id)
  }
  for (let node_id in dataNew) {
    let node = dataNew[node_id]
    var parents = []
    var condition = {}
    var children = []
    node.parents.forEach(function (parent_id) {
      parents.push(dataNew[parent_id].flow_id)
    })
    node.children.forEach(function (child_id) {
      children.push(dataNew[child_id].flow_id)
    })
    for (let parent_id in node.condition) {
      condition[dataNew[parent_id].flow_id] = node.condition[parent_id]
    }
    node.parents = parents
    node.children = children
    node.condition = condition
  }
  return dataNew

}

export function data2Lf(data) {
  var lfData = {
    nodes: [],
    edges: [],
  }
  if (data === []) {
    return lfData
  }
  console.log('data2Lf', data)
  var flow_ids = {}
  var nodes = {}
  for (let node_id in data) {
    let node = data[node_id]
    var node_data = {
      id: node.id,
      type: 'custom-rect',
      text: {
        x: node.x,
        y: node.y,
        value: node.name,
      },
      x: node.x,
      y: node.y,
      properties: {
        type: node.flow_id === 0 ? 'start' : (node.flow_id === -1 ? 'end' : 'node'),
        name: node.name,
        approval: node.approval,
        condition: node.condition,
        widgets: node.widgets,
        members: node.members,
        comment: node.comment,
      },
    }
    lfData.nodes.push(node_data)
    flow_ids[node.flow_id] = node.id
    nodes[node.flow_id] = node
  }
  for (let node_id in data) {
    let node = data[node_id]
    node.parents.forEach(function (parent_id) {
      let parent = nodes[parent_id]
      var condition = {}
      let edge_data = {
        id: 'edge_' + parent_id + '_' + node.flow_id,
        type: 'custom-line',
        sourceNodeId: flow_ids[parent_id],
        targetNodeId: node.id,
        startPoint: {x: parent.x, y: parent.y + 20},
        endPoint: {x: node.x, y: node.y - 20},
        properties: {type: 'line'},
      }
      if (typeof node.condition[parent_id] !== 'undefined') {
        edge_data.properties['condition'] = node.condition[parent_id]
      }
      lfData.edges.push(edge_data)
    })
  }
  // console.log("lfData", lfData);
  return lfData
}

export function user_trees(data) {
  if (typeof data === 'undefined') {
    return []
  }
  var result = []
  var dept_children = []
  for (let _dept in data.depts) {
    dept_children.push({
      id: _dept,
      label: data.depts[_dept],
    })
  }
  result.push({
    id: 'dept',
    label: '部门',
    children: dept_children,
  })
  var role_children = []
  for (let _role in data.roles) {
    role_children.push({
      id: _role,
      label: data.roles[_role],
    })
  }
  result.push({
    id: 'role',
    label: '角色',
    children: role_children,
  })
  var user_children = []
  for (let _user in data.users) {
    user_children.push({
      id: data.users[_user].username,
      label: data.users[_user].nickname,
    })
  }
  result.push({
    id: 'user',
    label: '用户',
    children: user_children,
  })
  return result
}

export function formatToTree(ary, pid) {
  return ary
    .filter((item) =>
    // 如果没有父id（第一次递归的时候）将所有父级查询出来
    // 这里认为 item.parentId === 0 就是最顶层 需要根据业务调整
      pid === undefined ? item.parent_id === 0 : item.parent_id === pid,
    )
    .map((item) => {
      // 通过父节点ID查询所有子节点
      item.children = formatToTree(ary, item.id)
      return item
    })
}

export function getAllWidgets(widgets) {
  console.log('getAllWidgets', widgets)
  var result = []
  widgets.forEach((widget) => {
    if (widget.type === 'linkquery') {
      if (!widget.options.multi) {
        widget.options.linkFields.forEach((linkField) => {
          result.push({
            key: linkField.name,
            model: linkField.name,
            name: linkField.text,
            type: linkField.type,
            options: {},
          })
        })
      }

    } else if (widget.type === 'grid') {
      widget.columns.forEach((column) => {
        column.list.forEach((field) => {
          result.push(field)
        })
      })
    } else {
      result.push(widget)
    }
  })
  return result
}

export function adjustColumnWidth(table) {
  // console.log('adjustColumnWidth', table)
  const colgroup = table.querySelector('colgroup')
  const colDefs = [...colgroup.querySelectorAll('col')]
  colDefs.forEach((col) => {

    const clsName = col.getAttribute('name')
    const cells = [
      ...table.querySelectorAll(`td.${
        clsName}`),
      ...table.querySelectorAll(`th.${
        clsName}`),
    ]
    // 忽略加了"leave-alone"类的列
    if (cells[0]?.classList?.contains?.('leave-alone')) {

      return
    }
    const widthList = cells.map((el) => {

      return el.querySelector('.cell')?.scrollWidth || 0
    })
    const max = Math.max(...widthList)
    const padding = 5
    table.querySelectorAll(`col[name=${
      clsName}]`).forEach((el) => {

      el.setAttribute('width', max + padding)
    })
  })
  const scrollingBody = table.querySelectorAll('div.is-scrolling-none')
  if (scrollingBody[0]?.classList?.contains?.('is-scrolling-none')) {

    scrollingBody[0].classList.remove('is-scrolling-none')
    scrollingBody[0].classList.add('is-scrolling-left')
    scrollingBody[0].style.overflowX = 'auto'
  }
}

export function getLastMonth() {
  var year, lastMonth
  var date = new Date()
  var nowYear = date.getFullYear()   //当前年：四位数字
  var nowMonth = date.getMonth()     //当前月：0-11
  if (nowMonth === 0) {   //如果是0，则说明是1月份，上一个月就是去年的12月
    year = nowYear - 1
    lastMonth = 12
  } else { //不是1月份，年份为当前年，月份本来是要减1的，但是由于`getMonth()`的月份本身就是少了1的，所以月份不用变。
    year = nowYear
    lastMonth = nowMonth
  }

  lastMonth = lastMonth < 10 ? ('0' + lastMonth) : lastMonth   //月份格式化：月份小于10则追加个0

  return year + '-' + lastMonth
}


let hDataItems = [
  {
    key: 'data0', name: '融资总额', parent: [
      {name: '融资额（万元）', colspan: 6, rowspan: 2},
    ], rowspan: 2, unit: '万元', row: 4,
  },
  {
    key: 'data1', name: '股东借款', parent: [
      {name: '其他', colspan: 5, row: 4},
    ], unit: '万元', row: 5,
  },
  {key: 'data2', name: '资产证券化', unit: '万元', row: 5},
  {key: 'data3', name: '银行融资', unit: '万元', row: 5},
  {key: 'data4', name: '同业拆借', unit: '万元', row: 5},
  {key: 'data5', name: '其他', unit: '万元', row: 5},
  {
    key: 'data6', name: '合计', parent: [
      {name: '财务情况', colspan: 12, rowspan: 2},
      {name: '资产总额', colspan: 3, row: 4},
    ], rowspan: 2, unit: '万元',
  },
  {key: 'data7', name: '其中：货币资金', unit: '万元'},
  {key: 'data8', name: '其中：其他资金运用', unit: '万元'},
  {key: 'data9', name: '实收资本', rowspan: 2, unit: '万元', row: 4},
  {key: 'data10', name: '负债总额', rowspan: 2, unit: '万元', row: 4},
  {
    key: 'data11', name: '合计', parent: [
      {name: '今年累计营业收入', colspan: 2, row: 4},
    ], unit: '万元',
  },
  {key: 'data12', name: '其中：今年累计利息收入', unit: '万元'},

  {
    key: 'data13', name: '合计', parent: [
      {name: '纳税支出', colspan: 3, row: 4},
    ], unit: '万元',
  },
  {key: 'data14', name: '其中：增值税支出', unit: '万元'},
  {key: 'data15', name: '其中：所得税支出', unit: '万元'},
  {key: 'data16', name: '净利润', rowspan: 2, unit: '万元', row: 4},
  {key: 'data70', name: '利润总额', rowspan: 2, unit: '万元', row: 4},
  {
    key: 'data17', name: '期末贷款余额', parent: [
      {name: '贷款情况', colspan: 47},
    ], rowspan: 3, unit: '万元', row: 3,
  },
  {key: 'data18', name: '其中：不良贷款余额', rowspan: 3, unit: '万元', row: 3},
  {key: 'data19', name: '不良率', rowspan: 3, unit: '万元', row: 3},
  {key: 'data20', name: '当月新增贷款额', rowspan: 3, unit: '万元', row: 3},

  {key: 'data63', name: '当月新增贷款笔数', rowspan: 3, unit: '笔', row: 3},
  // {key: 'data64', name: '当年新增贷款笔数', rowspan: 3, unit: '万元', row: 3},
  {key: 'data65', name: '当年累计新增贷款额', rowspan: 3, unit: '万元', row: 3},
  {key: 'data66', name: '当年累计新增贷款户数', rowspan: 3, unit: '户', row: 3},
  {key: 'data67', name: '在贷总户数', rowspan: 3, unit: '户', row: 3},
  {key: 'data69', name: '在贷总笔数', rowspan: 3, unit: '笔', row: 3},
  {
    key: 'data21', name: '余额', parent: [
      {name: '企业贷款', colspan: 12, row: 3},
      {name: '涉农贷款（含企业涉农部分）', colspan: 4, row: 4},
    ], unit: '万元',
  },
  {key: 'data22', name: '户数', unit: '户'},
  {key: 'data23', name: '当年累计发放金额', unit: '万元'},
  {key: 'data24', name: '当年累计发放户数', unit: '户'},
  {
    key: 'data25', name: '余额', parent: [
      {name: '小微企业（不含涉农）', colspan: 4, row: 4},
    ], unit: '万元',
  },
  {key: 'data26', name: '户数', unit: '户'},
  {key: 'data27', name: '当年累计发放金额', unit: '万元'},
  {key: 'data28', name: '当年累计发放户数', unit: '户'},
  {
    key: 'data29', name: '余额', parent: [
      {name: '其他企业', colspan: 4, row: 4},
    ], unit: '万元',
  },
  {key: 'data30', name: '户数', unit: '户'},
  {key: 'data31', name: '当年累计发放金额', unit: '万元'},
  {key: 'data32', name: '当年累计发放户数', unit: '户'},
  {
    key: 'data33', name: '余额', parent: [
      {name: '个人贷款', colspan: 16, row: 3},
      {name: '农民贷款', colspan: 4, row: 4},
    ], unit: '万元',
  },
  {key: 'data34', name: '户数', unit: '户'},
  {key: 'data35', name: '当年累计发放金额', unit: '万元'},
  {key: 'data36', name: '当年累计发放户数', unit: '户'},
  {
    key: 'data37', name: '余额', parent: [
      {name: '小微企业主', colspan: 4, row: 4},
    ], unit: '万元',
  },
  {key: 'data38', name: '户数', unit: '户'},
  {key: 'data39', name: '当年累计发放金额', unit: '万元'},
  {key: 'data40', name: '当年累计发放户数', unit: '户'},
  {
    key: 'data41', name: '余额', parent: [
      {name: '个体工商户', colspan: 4, row: 4},
    ], unit: '万元',
  },
  {key: 'data42', name: '户数', unit: '户'},
  {key: 'data43', name: '当年累计发放金额', unit: '万元'},
  {key: 'data44', name: '当年累计发放户数', unit: '户'},
  {
    key: 'data45', name: '余额', parent: [
      {name: '其它', colspan: 4, row: 4},
    ], unit: '万元',
  },
  {key: 'data46', name: '户数', unit: '户'},
  {key: 'data47', name: '当年累计发放金额', unit: '万元'},
  {key: 'data48', name: '当年累计发放户数', unit: '户'},
  {
    key: 'data49', name: '余额', parent: [
      {name: '按资产质量划分', colspan: 6, row: 3},
      {name: '正常贷款', colspan: 2, row: 4},
    ], unit: '万元',
  },
  {
    key: 'data50', name: '户数', parent: [], unit: '户',
  },
  {
    key: 'data51', name: '余额', parent: [
      {name: '逾期90天-180天', colspan: 2, row: 4},
    ], unit: '万元',
  },
  {
    key: 'data52', name: '户数', unit: '户',
  },
  {
    key: 'data53', name: '余额', parent: [
      {name: '逾期180天以上', colspan: 2, row: 4},
    ], unit: '万元',
  },
  {
    key: 'data54', name: '户数', unit: '户',
  },
  {
    key: 'data55', name: '单笔最高利率', parent: [
      {name: '利率水平', colspan: 4, rowspan: 2, row: 3},
    ], unit: '%',
  },
  {key: 'data56', name: '单笔最低利率', unit: '%'},
  {key: 'data57', name: '贷款综合融资成本年化费率', unit: '%'},
  {key: 'data68', name: '新增贷款综合融资成本平均年化费率(2026年新增部分)', unit: '%'},
  {
    key: 'data58', name: '从业人员', rowspan: 4, unit: '个', row: 2,
  },
  {
    key: 'data59', name: '线上贷款余额', parent: [
      {name: '网络小贷公司额外填', colspan: 4},
      {name: '网络小贷情况', colspan: 2, row: 3},
    ], rowspan: 2, unit: '万元', row: 4,
  },
  {key: 'data60', name: '线上贷款户数', rowspan: 2, unit: '户', row: 4},
  {
    key: 'data61', name: '跨省贷款余额', parent: [
      {name: '跨省展业情况', colspan: 2, row: 3},
    ], rowspan: 2, unit: '万元', row: 4,
  },
  {key: 'data62', name: '跨省贷款户数', rowspan: 2, unit: '户', row: 4},
]
export var hData = {row2: [], row3: [], row4: [], row5: []}
export var row_keys = []
hDataItems.forEach(item => {
  row_keys.push(item.key)
  if (item.row) {
    hData['row' + item.row].push(item)
  } else {
    hData.row5.push(item)
  }
  if (item.parent) {
    item.parent.forEach(parent => {
      if (parent.row) {
        hData['row' + parent.row].push(parent)
      } else {
        hData.row2.push(parent)
      }
    })
  }
})
export const areas = [
  {
    'value': 'cs',
    'label': '长沙',
    'children': [
      {
        'value': 'frq',
        'label': '芙蓉区',
      },
      {
        'value': 'txq',
        'label': '天心区',
      },
      {
        'value': 'kfq',
        'label': '开福区',
      },
      {
        'value': 'yhq',
        'label': '雨花区',
      },
      {
        'value': 'csx',
        'label': '长沙县',
      },
      {
        'value': 'jkq',
        'label': '长沙经开区',
      },
      {
        'value': 'wcq',
        'label': '望城区',
      },
      {
        'value': 'nxx',
        'label': '宁乡市',
      },
      {
        'value': 'lys',
        'label': '浏阳市',
      },
      {
        'value': 'xjxq',
        'label': '湘江新区',
      },
    ],
  },
  {
    'value': 'hy',
    'label': '衡阳',
    'children': [
      {
        'value': 'yfq',
        'label': '雁峰区',
      },
      {
        'value': 'sgq',
        'label': '石鼓区',
      },
      {
        'value': 'zxq',
        'label': '蒸湘区',
      },
      {
        'value': 'hsx',
        'label': '衡山县',
      },
      {
        'value': 'lys',
        'label': '耒阳市',
      },
      {
        'value': 'gxq',
        'label': '高新区',
      },
    ],
  },
  {
    'value': 'zz',
    'label': '株洲',
    'children': [
      {
        'value': 'tyq',
        'label': '天元区',
      },
      {
        'value': 'yx',
        'label': '攸县',
      },
      {
        'value': 'clx',
        'label': '茶陵县',
      },
      {
        'value': 'ylx',
        'label': '炎陵县',
      },
      {
        'value': 'lls',
        'label': '醴陵市',
      },
    ],
  },
  {
    'value': 'xt',
    'label': '湘潭',
    'children': [
      {
        'value': 'yhq',
        'label': '雨湖区',
      },
      {
        'value': 'ytjjkfq',
        'label': '岳塘经济开发区',
      },
      {
        'value': 'xtx',
        'label': '湘潭县',
      },
      {
        'value': 'xx',
        'label': '湘乡',
      },
      {
        'value': 'gxq',
        'label': '高新区',
      },
      {
        'value': 'xtjkq',
        'label': '湘潭经开区',
      },
    ],
  },
  {
    'value': 'sy',
    'label': '邵阳',
    'children': [
      {
        'value': 'dxq',
        'label': '大祥区',
      },
      {
        'value': 'sds',
        'label': '邵东市',
      },
      {
        'value': 'lhx',
        'label': '隆回县',
      },
      {
        'value': 'xnx',
        'label': '新宁县',
      },
      {
        'value': 'wgs',
        'label': '武冈市',
      },
    ],
  },
  {
    'value': 'yueyang',
    'label': '岳阳',
    'children': [
      {
        'value': 'yxq',
        'label': '云溪区',
      },
      {
        'value': 'jsq',
        'label': '君山区',
      },
      {
        'value': 'yyx',
        'label': '岳阳县',
      },
      {
        'value': 'xyx',
        'label': '湘阴县',
      },
      {
        'value': 'pjx',
        'label': '平江县',
      },
      {
        'value': 'mls',
        'label': '汨罗市',
      },
      {
        'value': 'yyjjjskfq',
        'label': '岳阳经济技术开发区',
      },
      {
        'value': 'yysyylq',
        'label': '岳阳市岳阳楼区',
      },
      {
        'value': 'xgq',
        'label': '新港区',
      },
      {
        'value': 'nhfjq',
        'label': '南湖风景区',
      },
    ],
  },
  {
    'value': 'cd',
    'label': '常德',
    'children': [
      {
        'value': 'wlq',
        'label': '武陵区',
      },
      {
        'value': 'dcq',
        'label': '鼎城区',
      },
      {
        'value': 'hsx',
        'label': '汉寿县',
      },
      {
        'value': 'lx',
        'label': '澧县',
      },
      {
        'value': 'llx',
        'label': '临澧县',
      },
      {
        'value': 'tyx',
        'label': '桃源县',
      },
      {
        'value': 'jss',
        'label': '津市市',
      },
      {
        'value': 'jkq',
        'label': '经开区',
      },
      {
        'value': 'xdt',
        'label': '西洞庭',
      },
      {
        'value': 'lyh',
        'label': '柳叶湖',
      },
    ],
  },
  {
    'value': 'zjj',
    'label': '张家界',
    'children': [
      {
        'value': 'ydq',
        'label': '永定区',
      },
      {
        'value': 'clx',
        'label': '慈利县',
      },
      {
        'value': 'szx',
        'label': '桑植县',
      },
    ],
  },
  {
    'value': 'yiyang',
    'label': '益阳',
    'children': [
      {
        'value': 'hsq',
        'label': '赫山区',
      },
      {
        'value': 'n  x',
        'label': '南  县',
      },
      {
        'value': 'tjx',
        'label': '桃江县',
      },
      {
        'value': 'yjs',
        'label': '沅江市',
      },
    ],
  },
  {
    'value': 'cz',
    'label': '郴州',
    'children': [
      {
        'value': 'bhq',
        'label': '北湖区',
      },
      {
        'value': 'gyx',
        'label': '桂阳县',
      },
      {
        'value': 'rcx',
        'label': '汝城县',
      },
      {
        'value': 'zxs',
        'label': '资兴市',
      },
      {
        'value': 'jkq',
        'label': '经开区',
      },
      {
        'value': 'arx',
        'label': '安仁县',
      },
    ],
  },
  {
    'value': 'yz',
    'label': '永州',
    'children': [
      {
        'value': 'lstq',
        'label': '冷水滩区',
      },
      {
        'value': 'qys',
        'label': '祁阳市',
      },
      {
        'value': 'spx',
        'label': '双牌县',
      },
      {
        'value': 'jyx',
        'label': '江永县',
      },
      {
        'value': 'jhx',
        'label': '江华县',
      },
      {
        'value': 'jkq',
        'label': '经开区',
      },
      {
        'value': 'nyx',
        'label': '宁远县',
      },
    ],
  },
  {
    'value': 'hh',
    'label': '怀化',
    'children': [
      {
        'value': 'hcq',
        'label': '鹤城区',
      },
      {
        'value': 'zfx',
        'label': '中方县',
      },
      {
        'value': 'ylx',
        'label': '沅陵县',
      },
      {
        'value': 'mymzzzx',
        'label': '麻阳苗族自治县',
      },
      {
        'value': 'zjdzzzx',
        'label': '芷江侗族自治县',
      },
      {
        'value': 'xhdzzzx',
        'label': '新晃侗族自治县',
      },
      {
        'value': 'jkq',
        'label': '经开区',
      },
    ],
  },
  {
    'value': 'ld',
    'label': '娄底',
    'children': [
      {
        'value': 'sfx',
        'label': '双峰县',
      },
      {
        'value': 'xhx',
        'label': '新化县',
      },
      {
        'value': 'lys',
        'label': '涟源市',
      },
      {
        'value': 'lxq',
        'label': '娄星区',
      },
      {
        'value': 'jkq',
        'label': '经开区',
      },
    ],
  },
  {
    'value': 'xxz',
    'label': '湘西州',
    'children': [
      {
        'value': 'jss',
        'label': '吉首市',
      },
    ],
  },
]

export let dataItems = [
  {
    key: 'data1', name: '股东借款', parent: [
      {name: '融资情况', rowspan: 5},
    ], colspan: 4, unit: '万元',
  },
  {key: 'data2', name: '资产证券化', colspan: 4, unit: '万元'},
  {key: 'data3', name: '银行融资', colspan: 4, unit: '万元'},
  {key: 'data4', name: '同业拆借', colspan: 4, unit: '万元'},
  {key: 'data5', name: '其他', colspan: 4, unit: '万元'},
  {
    key: 'data6', name: '资产总额', parent: [
      {name: '财务情况', rowspan: 12},
    ], colspan: 4, unit: '万元',
  },
  {key: 'data7', name: '其中：货币资金', colspan: 4, unit: '万元'},
  {key: 'data8', name: '其中：其他资金运用', colspan: 4, unit: '万元'},
  {key: 'data9', name: '实收资本', colspan: 4, unit: '万元'},
  {key: 'data10', name: '负债总额', colspan: 4, unit: '万元'},
  {key: 'data11', name: '今年累计营业收入', colspan: 4, unit: '万元'},
  {key: 'data12', name: '其中：今年累计贷款利息收入', colspan: 4, unit: '万元'},
  {key: 'data13', name: '纳税支出', colspan: 4, unit: '万元'},
  {key: 'data14', name: '其中：增值税支出', colspan: 4, unit: '万元'},
  {key: 'data15', name: '其中：所得税支出', colspan: 4, unit: '万元'},
  {key: 'data16', name: '净利润', colspan: 4, unit: '万元'},
  {key: 'data70', name: '利润总额', colspan: 4, unit: '万元'},
  {
    key: 'data17', name: '贷款余额', parent: [
      {name: '贷款情况', rowspan: 47},
    ], colspan: 4, unit: '万元',
  },
  {key: 'data18', name: '其中：不良贷款余额', colspan: 4, unit: '万元'},
  {key: 'data19', name: '不良率', colspan: 4, unit: '%', max: 100, min: 0},
  {key: 'data20', name: '当月新增贷款额', colspan: 4, unit: '万元'},
  {key: 'data63', name: '当月新增贷款笔数', colspan: 4, unit: '笔', precision: 0},
  // {key: 'data64', name: '当年新增贷款笔数', colspan: 4, unit: '万元', precision: 0},
  {key: 'data65', name: '当年累计新增贷款额', colspan: 4, unit: '万元'},
  {key: 'data66', name: '当年累计新增贷款户数', colspan: 4, unit: '户', precision: 0},
  {key: 'data67', name: '在贷总户数', colspan: 4, unit: '户', row: 3, precision: 0},
  {key: 'data69', name: '在贷总笔数', colspan: 4, unit: '笔', row: 3, precision: 0},
  {
    key: 'data21', name: '余额', parent: [
      {name: '按服务对象划分', rowspan: 28},
      {name: '企业贷款', rowspan: 12},
      {name: '涉农贷款（含企业涉农部分）', rowspan: 4},
    ], unit: '万元',
  },
  {key: 'data22', name: '户数', unit: '户', precision: 0},
  {key: 'data23', name: '当年累计发放金额', unit: '万元'},
  {key: 'data24', name: '当年累计发放户数', unit: '户', precision: 0},
  {
    key: 'data25', name: '余额', parent: [
      {name: '小微企业（不含涉农）', rowspan: 4},
    ], unit: '万元',
  },
  {key: 'data26', name: '户数', unit: '户', precision: 0},
  {key: 'data27', name: '当年累计发放金额', unit: '万元'},
  {key: 'data28', name: '当年累计发放户数', unit: '户', precision: 0},
  {
    key: 'data29', name: '余额', parent: [
      {name: '其他企业', rowspan: 4},
    ], unit: '万元',
  },
  {key: 'data30', name: '户数', unit: '户', precision: 0},
  {key: 'data31', name: '当年累计发放金额', unit: '万元'},
  {key: 'data32', name: '当年累计发放户数', unit: '户', precision: 0},
  {
    key: 'data33', name: '余额', parent: [
      {name: '个人贷款', rowspan: 16},
      {name: '农民贷款', rowspan: 4},
    ], unit: '万元',
  },
  {key: 'data34', name: '户数', unit: '户', precision: 0},
  {key: 'data35', name: '当年累计发放金额', unit: '万元'},
  {key: 'data36', name: '当年累计发放户数', unit: '户', precision: 0},
  {
    key: 'data37', name: '余额', parent: [
      {name: '小微企业主', rowspan: 4},
    ], unit: '万元',
  },
  {key: 'data38', name: '户数', unit: '户', precision: 0},
  {key: 'data39', name: '当年累计发放金额', unit: '万元'},
  {key: 'data40', name: '当年累计发放户数', unit: '户', precision: 0},
  {
    key: 'data41', name: '余额', parent: [
      {name: '个体工商户', rowspan: 4},
    ], unit: '万元',
  },
  {key: 'data42', name: '户数', unit: '户', precision: 0},
  {key: 'data43', name: '当年累计发放金额', unit: '万元'},
  {key: 'data44', name: '当年累计发放户数', unit: '户', precision: 0},
  {
    key: 'data45', name: '余额', parent: [
      {name: '其它', rowspan: 4},
    ], unit: '万元',
  },
  {key: 'data46', name: '户数', unit: '户', precision: 0},
  {key: 'data47', name: '当年累计发放金额', unit: '万元'},
  {key: 'data48', name: '当年累计发放户数', unit: '户', precision: 0},
  {
    key: 'data49', name: '余额', parent: [
      {name: '按资产质量划分', rowspan: 6},
      {name: '正常贷款', rowspan: 2},
      {name: ''},
    ], unit: '万元',
  },
  {
    key: 'data50', name: '户数', parent: [
      {name: ''},
    ], unit: '户', precision: 0,
  },
  {
    key: 'data51', name: '余额', parent: [
      {name: '逾期90天-180天', rowspan: 2},
      {name: ''},
    ], unit: '万元',
  },
  {
    key: 'data52', name: '户数', parent: [
      {name: ''},
    ], unit: '户', precision: 0,
  },
  {
    key: 'data53', name: '余额', parent: [
      {name: '逾期180天以上', rowspan: 2},
      {name: ''},
    ], unit: '万元',
  },
  {
    key: 'data54', name: '户数', parent: [
      {name: ''},
    ], unit: '户', precision: 0,
  },
  {
    key: 'data55', name: '单笔最高利率', parent: [
      {name: '利率水平', rowspan: 4},
    ], colspan: 3, unit: '%', min: 0,
  },
  {key: 'data56', name: '单笔最低利率', colspan: 3, unit: '%'},
  {key: 'data57', name: '贷款综合融资成本年化费率', colspan: 3, unit: '%'},
  {key: 'data68', name: '新增贷款综合融资成本平均年化费率(2026年新增部分)', colspan: 3, unit: '%'},
  {
    key: 'data58', name: '从业人数', parent: [
      {name: '其它'},
    ], colspan: 4, unit: '个', precision: 0,
  },
  {
    key: 'data59', name: '线上贷款余额', parent: [
      {name: '网络小贷业务', rowspan: 4},
      {name: '开展网络小贷业务的', rowspan: 2},
    ], colspan: 3, unit: '万元',
  },
  {key: 'data60', name: '贷款户数', colspan: 3, unit: '户', precision: 0},
  {
    key: 'data61', name: '跨省贷款余额', parent: [
      {name: '跨省展业情况', rowspan: 2},
    ], colspan: 3, unit: '万元',
  },
  {key: 'data62', name: '跨省贷款户数', colspan: 3, unit: '户', precision: 0},
]


window.AREA =  {
  PROVINCE: 'province', CITY: 'city', DISTRICT: 'district', COMPANY: 'company',
}
